/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { displayModal } from '@insticator/insticator-ui';
// component
import PreviewPage from 'pages/dashboard/embeds/management/preview/preview';



/* ========== ~~~~~~~~~~ EMBED PREVIEW : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }) => ({
    embedLocation: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.location,
});

// map actions
const mapDispatchToProps = dispatch => ({
	displayModal: (isVisible, contentToDisplay, showCloseButton) => {
        dispatch(displayModal(isVisible, contentToDisplay, showCloseButton))
    }
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
	mapStateToProps,
    mapDispatchToProps
)(PreviewPage);
